import { SrxApi } from '../api/SrxApi';

/**
 * Calls the widget API; falls back to dummyData when the request fails or returns no rows.
 * Used by ALF High Cost Denials until the real API is wired up — change path in WidgetsData only.
 */
export async function fetchWidgetAlertsWithDummyFallback(url, dummyData) {
    try {
        const { data } = await SrxApi.get(url);

        if (data?.results?.length) {
            return data;
        }

        if (dummyData?.length) {
            return buildDummyResponse(dummyData);
        }

        return data;
    } catch (err) {
        if (dummyData?.length) {
            return buildDummyResponse(dummyData);
        }
        throw err;
    }
}

function buildDummyResponse(dummyData) {
    return {
        results: dummyData,
        count: dummyData.length,
        timeStamp: new Date().toISOString(),
        cursor: null,
        nextPage: null,
    };
}
